export default [
  { value: 'fixed', text: 'Fijo' },
  { value: 'flexible', text: 'Flexible' },
  { value: 'full-time', text: 'Tiempo completo' },
]